import { API } from '../api';
import { IGetChatByIdPayload, IGetChatByIdResponse, IGetChatDatingByIdPayload, IGetChatDatingByIdResponse } from '../types/chat';

const endPoint = {
  chatDetail: 'v1/user-service/users/content-message',
  chatDatingDetail: '/v1/user-service/datings/content-message',
};

export const chatService = {
  async getChatById(payload: IGetChatByIdPayload) {
    const { data } = await API.post<IGetChatByIdResponse>(endPoint.chatDetail, payload);
    return data;
  },

  async getChatDatingById(payload: IGetChatDatingByIdPayload) {
    const { data } = await API.post<IGetChatDatingByIdResponse>(endPoint.chatDatingDetail, payload);
    return data.data;
  },
};
